/* eslint-disable */
import { Row, TableOptions } from 'react-table';

import { RowColor } from 'types';

import { Loader } from 'components/Loader';

import { useTableComponent } from './Table.hooks';
import * as S from './Table.styles';
import { StyledTableProps } from './Table.styles';
import { Body } from './components/Body';
import { Head } from './components/Head';
import { Pagination } from './components/Pagination';
import { SortItem } from './types';

type TableProps = TableOptions<{}> & {
  className?: string;
  defaultSortItems?: SortItem[];
  isSortable?: boolean;
  hasPagination?: boolean;
  isLoading?: boolean;
  renderRowColor?: (row: Row) => RowColor;
  hasApiSorting?: boolean;
  children?: React.ReactNode;
  additionalHeaders?: React.ReactNode;
  onRowClick?: (row: Row) => void;
} & StyledTableProps;

const defaultProps: Partial<TableProps> = {
  motive: 'default',
  isSortable: false,
  defaultSortItems: [],
  hasPagination: false,
  hasApiSorting: false,
  children: undefined,
};

export function Table(props: TableProps): React.ReactElement {
  const {
    columns,
    data,
    className,
    motive,
    defaultSortItems,
    isSortable,
    hasPagination,
    isLoading = false,
    renderRowColor,
    hasApiSorting,
    children,
    additionalHeaders,
    onRowClick,
  } = {
    ...defaultProps,
    ...props,
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    allColumns,
    rows,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    pageCount,
    pageSize,
    pageIndex,
  } = useTableComponent(columns, data, defaultSortItems, hasApiSorting);

  return (
    <Loader isLoading={isLoading}>
      <S.TableWrapper>
        <S.Table {...getTableProps()} className={className} motive={motive}>
          <Head
            isSortable={isSortable}
            headerGroups={headerGroups}
            additionalHeaders={additionalHeaders}
          />

          <Body
            renderRowColor={renderRowColor}
            data={data}
            getTableBodyProps={getTableBodyProps}
            rows={rows}
            prepareRow={prepareRow}
            onRowClick={onRowClick}
            columnsCount={allColumns.length}
          />
          {children ? <tfoot>{children}</tfoot> : undefined}
        </S.Table>
      </S.TableWrapper>

      {hasPagination && data && data.length > 0 ? (
        <Pagination
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          gotoPage={gotoPage}
          previousPage={previousPage}
          nextPage={nextPage}
          pageIndex={pageIndex}
          pageSize={pageSize}
          pageOptions={pageOptions}
          setPageSize={setPageSize}
          pageCount={pageCount}
        />
      ) : null}
    </Loader>
  );
}
